var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaturaIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8635,
    cy: 26.8635,
    r: 26.8635,
    fill: "#00C496"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8927 10.4097L38.9517 18.7206V43.6533H14.7745V10.4097H30.8927ZM16.7893 12.4874V14.5651H28.8779V12.4874H16.7893ZM30.8927 18.7206H36.937L30.8927 12.4874V18.7206ZM16.7893 16.6428V18.7206H28.8779V16.6428H16.7893ZM36.937 22.876V20.7983H16.7893V22.876H36.937ZM16.7893 24.9538V27.0315H24.8484V24.9538H16.7893ZM36.937 31.1869V24.9538H26.8631V31.1869H36.937ZM16.7893 29.1092V31.1869H24.8484V29.1092H16.7893ZM36.937 35.3424V33.2647H16.7893V35.3424H36.937ZM30.8927 39.4978V37.4201H16.7893V39.4978H30.8927Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaturaIconGreen);
export default __webpack_public_path__ + "static/media/faturaIconGreen.224dce27cf5fb97344ca77538977c680.svg";
export { ForwardRef as ReactComponent };